import { computed, watch, onMounted } from 'vue'
// @ts-expect-error: vuex is not typped. It will be migrated to typed pinia in the future.
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

interface RouteMeta {
  requireAuth?: boolean
}

export function useAuth() {
  const store = useStore()
  const route = useRoute()

  const isLogged = computed<boolean>(() => store.getters['auth/isLogged'])

  /**
   * Redirects the user to the login page by reloading the current page.
   *
   * This function checks if the current route requires authentication by inspecting
   * the `requireAuth` property in the route's metadata. If authentication is required,
   * the page is reloaded to clear Vuex and Pinia stores. The `authRouteGuard` will then
   * handle navigating the user to the login page, so a direct `router.push` call is not needed here.
   */
  const redirectToLoginPage = (): void => {
    if (route) {
      const { requireAuth } = route.meta as RouteMeta
      if (requireAuth) {
        window.location.reload()
      }
    }
  }

  watch(isLogged, (newValue: boolean) => {
    if (newValue !== true) {
      redirectToLoginPage()
    }
  })

  onMounted(() => {
    if (isLogged.value) {
      store.dispatch('auth/tokenRegeneration')
    }
  })

  return {
    isLogged,
    redirectToLoginPage
  }
}
